import { getTheme } from "@clipboard-health/ui-theme";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { type ReactElement } from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";

import { ModalRoute } from "../Navigation/ModalRoute";
import { ModalTransitionSwitch } from "../Navigation/ModalTransitionSwitch";
import { ClipboardScoreAdjustments } from "./components/Adjustments/Page";
import { NoShowBottomSheet } from "./components/BottomSheets/NoShowBottomSheet";
import { WorkerLeftEarlyBottomSheet } from "./components/BottomSheets/WorkerLeftEarlyBottomSheet";
import { ClipboardScoreHistory } from "./components/History/Page";
import { ClipboardScoreNeverNoShow } from "./components/NeverNoShow/Page";
import { ClipboardScorePage } from "./components/Page/Page";
import { ShareScorePage } from "./components/ShareScore/ShareScorePage";
import {
  CLIPBOARD_SCORE_ADJUSTMENTS_PATH,
  CLIPBOARD_SCORE_HISTORY_PATH,
  CLIPBOARD_SCORE_NEVER_NO_SHOW_MODAL_PATH,
  CLIPBOARD_SCORE_NO_SHOW_MODAL_PATH,
  CLIPBOARD_SCORE_SHARE_PATH,
  CLIPBOARD_SCORE_WORKER_LEFT_EARLY_MODAL_PATH,
} from "./utils/paths";

export function ClipboardScoreRoutes(): ReactElement {
  const match = useRouteMatch();

  return (
    <ThemeProvider theme={getTheme()}>
      <CssBaseline />
      <Route exact path={`${match.url}`}>
        <ClipboardScorePage />
      </Route>
      <Switch>
        <Route exact path={`${match.url}/${CLIPBOARD_SCORE_SHARE_PATH}`}>
          <ShareScorePage />
        </Route>
        <Route exact path={`${match.url}/${CLIPBOARD_SCORE_ADJUSTMENTS_PATH}`}>
          <ClipboardScoreAdjustments />
        </Route>
        <Route exact path={`${match.url}/${CLIPBOARD_SCORE_HISTORY_PATH}`}>
          <ClipboardScoreHistory />
        </Route>
        <Route exact path={`${match.url}/${CLIPBOARD_SCORE_NEVER_NO_SHOW_MODAL_PATH}`}>
          <ClipboardScoreNeverNoShow />
        </Route>
      </Switch>
      <ModalTransitionSwitch>
        <ModalRoute
          shouldReplacePathOnBack
          closeModalPath={match.url}
          path={`${match.url}/${CLIPBOARD_SCORE_NO_SHOW_MODAL_PATH}`}
          render={({ modalState }) => <NoShowBottomSheet modalState={modalState} />}
        />
        <ModalRoute
          shouldReplacePathOnBack
          closeModalPath={match.url}
          path={`${match.url}/${CLIPBOARD_SCORE_WORKER_LEFT_EARLY_MODAL_PATH}`}
          render={({ modalState }) => <WorkerLeftEarlyBottomSheet modalState={modalState} />}
        />
      </ModalTransitionSwitch>
    </ThemeProvider>
  );
}
